/* The Buddy panel over the builder's week: boards I and S (`.panel`, `.ph`, `.disc`). 448px,
 * overlaying the right edge under the top bar as the day panel does, the week keeping its widths
 * (owner, 7 October 2026; S draws it narrowing the week). The subtitle the boards set in the
 * tertiary ink is drawn in the secondary one, as in the rest of the conversation. */

.panel {
  position: fixed;
  z-index: 20;
  inset-block: var(--h-app-bar) 0;
  inset-inline-end: 0;
  display: flex;
  flex-direction: column;
  width: var(--w-buddy-panel);
  max-width: 100vw;
  background: var(--bg-card);
  border-left: var(--border-hairline) solid var(--border);
  box-shadow: var(--shadow-sheet);
}

.head {
  display: flex;
  flex: none;
  gap: var(--space-10px);
  align-items: center;
  padding: var(--space-4) var(--space-18px) var(--space-10px);
}

.headMark {
  width: 30px;
  height: 30px;
}

.headText {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
}

.title {
  margin: var(--space-0);
  font-size: var(--fs-button);
  font-weight: var(--fw-extrabold);
  letter-spacing: var(--ls-heading);
}

.subtitle {
  margin: var(--space-0);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}

.icon {
  display: grid;
  flex: none;
  place-items: center;
  width: 32px;
  height: 32px;
  padding: var(--space-0);
  color: var(--text-2);
  cursor: pointer;
  background: none;
  border: var(--border-hairline) solid var(--border);
  border-radius: var(--radius-mark);
}

.icon:focus-visible {
  outline: var(--border-focus) solid var(--focus);
  outline-offset: var(--space-2px);
}

.icon:hover:not([aria-disabled='true']) {
  color: var(--text);
}

.icon[aria-disabled='true'] {
  cursor: default;
  opacity: 0.4;
}

.iconGlyph {
  width: 15px;
  height: 15px;
}

.disclosure {
  flex: none;
  margin: var(--space-0) var(--space-18px);
  padding: var(--space-9px) var(--space-3);
  font-size: var(--fs-label);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
  background: var(--bg-sunken);
  border-radius: var(--radius-sm);
}

.body {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.chat {
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
}

.state {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: var(--space-3);
  align-items: center;
  justify-content: center;
  padding: var(--space-6);
  text-align: center;
}

.stateMark {
  width: 36px;
  height: 36px;
}

.stateText {
  margin: var(--space-0);
  font-size: var(--fs-foot);
  font-weight: var(--fw-semibold);
  color: var(--text-2);
}
